import { gql, useMutation } from '@apollo/client';
import { GET_DOCUMENTS_IMPORTER } from './get-documents-importer.hook';
import { GET_DOCUMENT_IMPORTER__BY_ID } from './get-document-importer-by-id.hook';

export const CREATE_DOCUMENT_IMPORTER = gql`
  mutation createDocumentImporter($payload: CreateDocumentImporterInput!) {
    createDocumentImporter(payload: $payload) {
      _id
      title
      companyId
    }
  }
`;

export const useCreateDocumentImporter = () => {
  const [createDocumentImporter, { loading }] = useMutation(CREATE_DOCUMENT_IMPORTER, {
    refetchQueries: [GET_DOCUMENTS_IMPORTER, GET_DOCUMENT_IMPORTER__BY_ID],
  });
  return { createDocumentImporter, loading };
};
